export default __webpack_public_path__ + "static/media/logo.97900704.png";